<div class="quantity-selector" fxLayout="row" fxLayoutAlign="space-between center">
  <spx-icon-button
    [disabled]="quantity <= 1 || disabled"
    [color]="'primary'"
    [type]="'mat-icon-button'"
    [iconName]="'remove'"
    (click)="onDecreaseQuantity($event)"></spx-icon-button>
  <span fxFlexAlign="center">{{ quantity }}</span>
  <spx-icon-button [disabled]="disabled" [color]="'primary'" [type]="'mat-icon-button'" [iconName]="'add'" (click)="onIncreaseQuantity($event)"></spx-icon-button>
</div>
